export default class Animations {
  OPTIONS = {
    rootMargin: '0% 0% 20%',
    threshold: 0
  };

  static init(ANIMATIONS = {}) {
    new Animations(ANIMATIONS);
  }

  static isVisible($target) {
    var style = window.getComputedStyle($target);
    var isHTMLHidden = $target.hidden;
    var isCSSHidden = style.display === 'none';

    return !isHTMLHidden && !isCSSHidden;
  }

  static calculateKeyFrame(animation, progress) {
    var valueRe = /([0-9.-]+)/g;
    var from = animation.from;
    var to = animation.to;
    var current = Object.assign({}, animation.inverted ? to : from);

    Object.keys(from).forEach((prop) => {
      var valuesFrom = from[prop].toString().match(valueRe);
      var valuesTo = to[prop].toString().match(valueRe);
      var valuesCurrent = valuesTo.map((value, index) => {
        var floatFrom = parseFloat(valuesFrom[index] || 0);
        var floatTo = parseFloat(valuesTo[index] || 0);

        return parseFloat((floatTo + (floatFrom - floatTo) * (1 - progress)).toFixed(3));
      });

      var replaceIndex = -1;
      current[prop] = current[prop].toString().replace(valueRe, function () {
        replaceIndex += 1;
        return valuesCurrent[replaceIndex];
      });
    });

    if (progress > 0 && progress < 1) {
      current['will-change'] = Object.keys(from).join(',');
    }

    return current;
  }

  static getOffsetTop($target) {
    var offsetTop = $target.offsetTop;
    while ($target.offsetParent) {
      $target = $target.offsetParent;
      offsetTop += $target.offsetTop;
    }

    return offsetTop;
  }

  getKeyFrameStyle(keyFrame) {
    var style = {};
    Object.keys(keyFrame).forEach((key) => {
      var prefixedProperty = window.Modernizr.prefixedCSS(key);
      if (!prefixedProperty) {
        prefixedProperty = key;
      }
      var prefixedValue = window.Modernizr.prefixedCSSValue(key, keyFrame[key]);
      if (!prefixedValue) {
        prefixedValue = keyFrame[key];
      }
      style[prefixedProperty] = prefixedValue;
    });

    return style;
  }

  addStyleTo(style, $target) {
    $target.style = Object.keys(style)
      .map((property) => {
        return `${property}:${style[property]}`;
      })
      .join(';');
  }

  getProgressFor($target) {
    var animationName = $target.dataset.entry;
    var speed = this.ANIMATIONS[animationName].speed || 1;
    var inverted = this.ANIMATIONS[animationName].inverted || false;

    var top = Animations.getOffsetTop($target);
    var duration = Math.max(window.innerHeight, $target.offsetHeight);
    var scrollTop = window.scrollY;

    if (inverted) {
      top = top + duration;
    }

    var progress = (scrollTop + duration - top) / (duration * (1 / speed));

    return Math.max(0, Math.min(1, progress));
  }

  processTarget($target, $parent) {
    var progress;
    var keyFrame;
    if ($target) {
      if ($parent) {
        var parentAnimationName = $parent.dataset.entry;
        var childAnimationName = $target.dataset.child;

        if (
          this.ANIMATIONS[parentAnimationName] &&
          this.ANIMATIONS[parentAnimationName].children[childAnimationName]
        ) {
          progress = this.getProgressFor($parent);

          if (this.ANIMATIONS[parentAnimationName].children[childAnimationName].from) {
            keyFrame = Animations.calculateKeyFrame(
              this.ANIMATIONS[parentAnimationName].children[childAnimationName],
              progress
            );
            this.addStyleTo(this.getKeyFrameStyle(keyFrame), $target);
          }
        }
      } else {
        var animationName = $target.dataset.entry;
        if (this.ANIMATIONS[animationName]) {
          progress = this.getProgressFor($target);
          if (this.ANIMATIONS[animationName].from) {
            keyFrame = Animations.calculateKeyFrame(this.ANIMATIONS[animationName], progress);
            this.addStyleTo(this.getKeyFrameStyle(keyFrame), $target);
          }

          if (this.ANIMATIONS[animationName].children) {
            Object.keys(this.ANIMATIONS[animationName].children).forEach((child) => {
              var $children = $target.querySelectorAll(`[data-child="${child}"]`);

              $children.forEach(($child) => {
                this.processTarget($child, $target);
              });
            });
          }
        }
      }
    }
  }

  processVisible() {
    if (this.VISIBLE) {
      Object.keys(this.VISIBLE).forEach((id) => {
        var $target = this.VISIBLE[id];

        this.processTarget($target);
      });
    }
  }

  constructor(ANIMATIONS) {
    this.ANIMATIONS = ANIMATIONS;
    this.$targets = document.body.querySelectorAll(`[data-entry]`);

    this.init();
  }

  generateId(input) {
    this._set = this._set || {};
    var id = ((input + 1) / Math.random()).toString(16).substr(-6);
    if (this._set[id]) {
      id = this.generateId(input);
    } else {
      this._set[id] = id;
    }
    return id;
  }

  init() {
    this.VISIBLE = {};

    this.$targets.forEach(($target, index) => {
      $target.dataset.id = this.generateId(index);
    });

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var $target = entry.target;
        var targetId = $target.dataset.id;

        if (entry.isIntersecting && Animations.isVisible($target)) {
          this.VISIBLE[targetId] = $target;
        } else if (this.VISIBLE[targetId]) {
          delete this.VISIBLE[targetId];
        }
      });
    }, this.OPTIONS);

    this.$targets.forEach(($target, index) => {
      this.observer.observe($target);
      this.processTarget($target);
    });

    window.addEventListener(
      'scroll',
      () => {
        this.processVisible();
      },
      {
        passive: false
      }
    );

    window.addEventListener(
      'resize',
      () => {
        this.processVisible();
      },
      {
        passive: false
      }
    );
  }

  destroy() {
    this.observer.disconnect();
  }
}
